import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

// Images for SPMs
import j73 from "../components/Assets/J73.webp";
import duv from "../components/Assets/DUV.webp";
import rap22b from "../components/Assets/22B.webp";
import eolTweeter from "../components/Assets/EOL_Tweeter.webp";
import bumperPP from "../components/Assets/Bumper_PP.webp";
import autoConnector from "../components/Assets/Auto_Connector.webp";
import radiator from "../components/Assets/Radiator.webp";
import grilleCamera from "../components/Assets/Grille_Camera.webp";

// Robotic Cells
import fca from "../components/Assets/FCA_Cell.webp";
import roboUS1 from "../components/Assets/Robotic_US1.webp";
import roboUS2 from "../components/Assets/Robotic_US2.webp";
import sierra from "../components/Assets/Sierra_Cell.webp";
import sk25 from "../components/Assets/SK2.5_Cell.webp";
import rowa from "../components/Assets/ROWA_Cell.webp";

// Assembly Lines
import assemblyLine from "../components/Assets/Assembly_Line.webp";
import tataEngine from "../components/Assets/Tata_Engine_Line.webp";

import Card from './../components/Commanbackgroundcard/Card';

const AutomationSolutionsPage = () => {
  // SPMs Data
  const spms = [
    { 
      name: "J73 - Sports Hoop Multihead US Welding SPM", 
      image: j73,
      description: "Advanced ultrasonic welding solution for sports components with multi-head configuration ensuring precision and high-speed production."
    },
    { 
      name: "DUV - FR Bumper Punching & US Welding SPM", 
      image: duv,
      description: "Integrated punching and ultrasonic welding system for automotive bumper manufacturing with quality control features."
    },
    { 
      name: "22B - RAP CAB Box Post Process SPM", 
      image: rap22b,
      description: "Specialized post-processing machine for automotive cabin components with automated handling and quality inspection."
    },
    { 
      name: "EOL Tweeter Testing SPM", 
      image: eolTweeter,
      description: "End-of-line testing solution for audio components ensuring quality standards and performance validation."
    },
    { 
      name: "Bumper Post Process SPM", 
      image: bumperPP,
      description: "Comprehensive post-processing solution for automotive bumpers including trimming, finishing, and quality checks."
    },
    { 
      name: "Automatic Connector Assembly & Testing SPM", 
      image: autoConnector,
      description: "Fully automated assembly and testing system for electrical connectors with precision placement and validation."
    },
    { 
      name: "Radiator Leak Testing SPM", 
      image: radiator,
      description: "High-precision leak testing system for automotive radiators with automated handling and reporting capabilities."
    },
    { 
      name: "Grille Camera Testing SPM", 
      image: grilleCamera,
      description: "Advanced testing solution for automotive grille camera systems ensuring functionality and calibration accuracy."
    },
  ];

  // Robotic Cells Data
  const roboticCells = [
    { 
      name: "FCA - FR / RR Bumper US Welding Cell", 
      image: fca,
      description: "Robotic welding cell for front and rear bumper assembly with integrated quality control and automated material handling."
    },
    { 
      name: "Robotic Ultrasonic Welding Cell 1", 
      image: roboUS1,
      description: "Flexible robotic cell for ultrasonic welding applications with programmable positioning and force control."
    },
    { 
      name: "Robotic Ultrasonic Welding Cell 2", 
      image: roboUS2,
      description: "Advanced robotic welding solution with vision guidance and real-time process monitoring capabilities."
    },
    { 
      name: "Sierra-Cladding US Welding Cell", 
      image: sierra,
      description: "Specialized robotic cell for cladding applications with ultrasonic welding technology and quality assurance."
    },
    { 
      name: "SK2.5 Deco Cluster US Welding Cell", 
      image: sk25,
      description: "Precision robotic welding cell for decorative cluster components with micro-positioning capabilities."
    },
    { 
      name: "ROWA - FR RR Bumper US Welding Cell", 
      image: rowa,
      description: "High-throughput robotic welding solution for automotive bumper production with integrated testing systems."
    },
  ];

  // Assembly Lines Data
  const assemblyLines = [
    { 
      name: "Assembly Line + Vision Camera Inspection Setup", 
      image: assemblyLine,
      description: "Complete assembly line solution integrated with advanced vision inspection systems for quality control and automated sorting."
    },
    { 
      name: "Tata Engine Cold Test Conveyor Line", 
      image: tataEngine,
      description: "Specialized conveyor system for engine testing with temperature control and automated data collection capabilities."
    },
  ];

  // Industries Data with better icons
  const industries = [
    { name: "Automotive Manufacturing", icon: "🚗" },
    { name: "Electrical & Electronics", icon: "⚡" },
    { name: "Aerospace", icon: "✈️" },
    { name: "Consumer Products", icon: "🏭" },
  ];

  // Why Choose Us
  const whyChoose = [
    "ISO 9001-2015 Certified (TUV Austria)",
    "ECOVADIS CSR – Silver Medal 2023",
    "Technical MOUs in Europe & Africa",
    "20+ Years of Expertise",
    "End-to-End Automation Solutions",
    "Global Presence with Projects in 15+ Countries",
  ];

  return (
    <div className="bg-gray-100 min-h-screen">
      <Navbar />

      {/* Page Heading Card */}
      <Card text="AUTOMATION & ROBOTIC SOLUTIONS" />

      {/* Intro Section - improved with better styling */}
      <section className="py-16 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Precision Automation for <span className="text-[#F49100]">High-Volume Manufacturing</span>
          </h2>
          <p className="text-gray-700 text-base lg:text-lg leading-relaxed max-w-4xl mx-auto">
            Metrolab Automation offers world-class solutions in automation and robotics, integrating advanced PLC controls, assembly lines, SPMs, and robotic cells. Our systems enhance quality, efficiency, and repeatability across manufacturing workflows, serving industries like automotive, aerospace, consumer products, and electrical equipment.
          </p>
        </div>
      </section>

      {/* SPMs Section - improved cards */}
      <section className="py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 text-center mb-4">
            Special Purpose <span className="text-[#F49100]">Machines (SPMs)</span>
          </h2>
          <p className="text-gray-700 text-center mb-12 max-w-3xl mx-auto">
            Custom-designed machines tailored to specific manufacturing requirements, ensuring optimal performance and reliability.
          </p>
          <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {spms.map((spm, i) => (
              <article key={i} className="bg-white rounded-2xl shadow-md hover:shadow-xl transition transform hover:-translate-y-2 duration-500 overflow-hidden border border-gray-100">
                <div className="relative group">
                  <img src={spm.image} alt={spm.name} className="w-full h-80 lg:h-96 lg:h-72 object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">{spm.name}</h3>
                  <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                    {spm.description}
                  </p>
                  {/* <button className="inline-block px-4 py-2 bg-[#F49100] text-white font-semibold rounded-lg hover:bg-[#d97900] transition duration-300 text-sm">
                    Learn More
                  </button> */}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Assembly Lines Section - improved layout */}
      <section className="py-16 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 text-center mb-4">
            Assembly <span className="text-[#F49100]">Lines</span>
          </h2>
          <p className="text-gray-700 text-center mb-12 max-w-3xl mx-auto">
            Complete assembly line solutions with integrated inspection systems and material handling for optimized production flow.
          </p>
          <div className="grid sm:grid-cols-1 lg:grid-cols-2 gap-10">
            {assemblyLines.map((line, i) => (
              <article key={i} className="bg-white rounded-2xl shadow-md hover:shadow-xl transition transform hover:-translate-y-2 duration-500 overflow-hidden">
                <div className="relative group">
                  <img src={line.image} alt={line.name} className="w-full h-80 lg:h-96 object-cover rounded-t-2xl transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent rounded-t-2xl pointer-events-none"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-semibold text-gray-800 mb-3">{line.name}</h3>
                  <p className="text-gray-700 mb-6 text-sm lg:text-base leading-relaxed">
                    {line.description}
                  </p>
                  {/* <button className="inline-block px-6 py-3 bg-[#F49100] text-white font-semibold rounded-lg hover:bg-[#d97900] transition duration-300">
                    Know More
                  </button> */}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Robotic Cells Section - improved cards */}
      <section className="py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 text-center mb-4">
            Robotic <span className="text-[#F49100]">Cells</span>
          </h2>
          <p className="text-gray-700 text-center mb-12 max-w-3xl mx-auto">
            Flexible robotic solutions for welding, assembly, and material handling with advanced programming and safety features.
          </p>
          <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {roboticCells.map((cell, i) => (
              <article key={i} className="bg-white rounded-2xl shadow-md hover:shadow-xl transition transform hover:-translate-y-2 duration-500 overflow-hidden border border-gray-100">
                <div className="relative group">
                  <img src={cell.image} alt={cell.name} className="w-full h-64 lg:h-72 object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">{cell.name}</h3>
                  <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                    {cell.description}
                  </p>
                  {/* <button className="inline-block px-4 py-2 bg-[#F49100] text-white font-semibold rounded-lg hover:bg-[#d97900] transition duration-300 text-sm">
                    Learn More
                  </button> */}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Industry Applications - improved styling */}
      <section className="py-16 px-6 lg:px-12 bg-gray-50">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Industry <span className="text-[#F49100]">Applications</span>
          </h2>
          <p className="text-gray-700 mb-12 max-w-3xl mx-auto">
            Our automation solutions serve diverse industries with customized approaches for each sector's unique requirements.
          </p>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8 max-w-5xl mx-auto">
            {industries.map((ind, i) => (
              <div key={i} className="flex flex-col items-center p-6 bg-white rounded-2xl shadow-md hover:shadow-lg transition duration-300 transform hover:-translate-y-1">
                <div className="text-5xl mb-4">{ind.icon}</div>
                <p className="text-gray-700 font-semibold text-center">{ind.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us - improved design */}
      <section className="py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 text-center mb-4">
            Why Choose <span className="text-[#F49100]">Us</span>
          </h2>
          <p className="text-gray-700 text-center mb-12 max-w-3xl mx-auto">
            Our commitment to excellence and innovation makes us the preferred partner for automation solutions worldwide.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {whyChoose.map((point, i) => (
              <div key={i} className="flex items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition duration-300">
                <div className="w-3 h-3 bg-[#F49100] rounded-full mr-4 flex-shrink-0"></div>
                <p className="text-gray-700 font-medium">{point}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA - improved styling */}
      <section className="py-16 px-6 lg:px-12 bg-[#F49100] text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">Ready to Optimize Your Manufacturing?</h2>
          <p className="mb-8 text-lg leading-relaxed">
            Contact us today to implement world-class automation and robotic solutions tailored to your production needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-block px-8 py-4 bg-white text-[#F49100] font-bold rounded-lg hover:bg-gray-100 transition duration-300"
            >
              Get in Touch
            </a>
            {/* <a
              href="/quote"
              className="inline-block px-8 py-4 bg-transparent border-2 border-white text-white font-bold rounded-lg hover:bg-white hover:text-[#F49100] transition duration-300"
            >
              Request Quote
            </a> */}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AutomationSolutionsPage;